import Cookies from 'js-cookie';

export const tokenState = () => ({
  token: Cookies.get('token') || '',
  id_token: Cookies.get('id_token') || '',
});

export const actions = {
  setToken({ commit }: any, tokens: { access_token: string, id_token: string }) {
    commit('setToken', tokens);
  },
  clearToken({ commit }: any) {
    commit('clearToken');
  },
};

export const mutations = {
  setToken(state: any, tokens: { access_token: string, id_token: string }) {
    Cookies.set('token', tokens.access_token);
    Cookies.set('id_token', tokens.id_token);
    state.token = tokens.access_token;
    state.id_token = tokens.id_token;
  },
  clearToken(state: any) {
    Cookies.remove('token');
    Cookies.remove('id_token');
    state.token = null;
    state.id_token = null;
  },
};

const getters = {
  token(state: any) {
    return state.token;
  },
  id_token(state: any) {
    return state.id_token;
  },
};

export default {
  namespaced: true,
  state: tokenState,
  actions,
  mutations,
  getters,
};
